import { Box, Typography } from "@mui/material";
import Picker from 'rmc-picker'
import '../utils/picker.css'
import { useState } from "react";
import { settingsInterface } from "../../../app/recipeCreation/createRecipe.types";
import { convertTime, getTimeObject } from "./getTime";

const TimePicker = ({ index, timeValue, localSetting }: { index: number, timeValue: number, localSetting: Array<settingsInterface> }) => {
  const { mins, secs } = getTimeObject(timeValue)
  const [minsValue, setMinsValue] = useState(mins)
  const [secValue, setSecValue] = useState(secs)

  const onMinsChange = (value: any) => {
    setMinsValue(value)
    localSetting[index].time = convertTime({ mins: value, secs: secValue })
  }
  const onSecChange = (value: any) => {
    setSecValue(value)
    localSetting[index].time = convertTime({ mins: minsValue, secs: value })
  }

  const valueArray = []
  for (let i = 0; i <= 60; i++) {
    valueArray.push(i);
  }
  return (
    <Box style={{ display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center' }}>
      <Picker indicatorClassName="my-picker-indicator"
        selectedValue={minsValue}
        onValueChange={onMinsChange}
      >
        {valueArray.map((value) => (
          <Picker.Item className='my-picker-view-item' value={value}><Typography variant='timeTextSettings'>{value}</Typography></Picker.Item>
        ))}
      </Picker>
      <Typography variant='caption3Light' sx={{ mt: '-7px' }}>m</Typography>
      <Typography variant='caption3Bold' sx={{ mt: '-8px', ml: '8px', mr: '-8px' }}>:</Typography>
      <Box sx={{ width: '50px !important' }}>

        <Picker indicatorClassName="my-picker-indicator"
          selectedValue={secValue}
          onValueChange={onSecChange}
        >
          {valueArray.map((value) => (
            <Picker.Item className='my-picker-view-item' value={value}><Typography variant='timeTextSettings'>{value}</Typography></Picker.Item>
          ))}
        </Picker>
      </Box>
      <Typography variant='caption3Light' sx={{ mt: '-7px' }}>s</Typography>
    </Box>
  )
}

export default TimePicker